/**
 * @generated SignedSource<<74566bd99807f69e434cfa02aa55b2a9>>
 * @relayHash 48253c273e6aab42de7754c1092fc3a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 09eb5c309b93132e17ec19c3a5fdc9e09d9d2320daa0d37c40ac6a46dc998281

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ToolchainLayoutQuery$variables = {
  cloudId: string;
};
export type ToolchainLayoutQuery$data = {
  readonly dvcs: {
    readonly bitbucketWorkspacesLinkedToSite: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "DvcsBitbucketWorkspaceEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ToolchainLayoutQuery = {
  response: ToolchainLayoutQuery$data;
  variables: ToolchainLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "DvcsQuery",
    "kind": "LinkedField",
    "name": "dvcs",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          }
        ],
        "concreteType": "DvcsBitbucketWorkspaceConnection",
        "kind": "LinkedField",
        "name": "bitbucketWorkspacesLinkedToSite",
        "plural": false,
        "selections": [
          {
            "concreteType": "DvcsBitbucketWorkspaceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ToolchainLayoutQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToolchainLayoutQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "09eb5c309b93132e17ec19c3a5fdc9e09d9d2320daa0d37c40ac6a46dc998281",
    "metadata": {},
    "name": "ToolchainLayoutQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "810499e5c2abc370d3d44631b8958e5f";

export default node;
